import { DateTime } from "luxon";

export const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"] as const;
export type Day = typeof DAYS[number];

export const DAY_NUMBER_MAP: Record<Day, number> = {
    "Monday": 0,
    "Tuesday": 1,
    "Wednesday": 2,
    "Thursday": 3,
    "Friday": 4,
    "Saturday": 5,
    "Sunday": 6
}

export const NUMBER_DAY_MAP: Record<number, Day> = {
    0: "Monday",
    1: "Tuesday",
    2: "Wednesday",
    3: "Thursday",
    4: "Friday",
    5: "Saturday",
    6: "Sunday"
}

export const RECURRENCE = ["weekly", "monthly"] as const;
export type Recurrence = typeof RECURRENCE[number];

export const RECURRENCE_DISPLAY_NAME_MAP: Record<Recurrence, string> = {
    "weekly": "Weekly",
    "monthly": "Monthly",
}

export type DateRange = {
    start: number | null,
    end: number | null
}

export function getDateRange(start: string, end: string): DateRange {
    return {
        start: getDate(start),
        end: getDate(end)
    }
}

function getDate(value: string) {
    if (!value) {
        return null;
    }

    const date = new Date(value);
    if (date.toString() === "Invalid Date") {
        return null;
    }

    return date.getTime();
}

export function getDateFromMilliseconds(millis: number): string {
    const date = new Date(millis);
    return date.toLocaleDateString();
}

export function getTimezoneJSDate(date: Date, timezone: string): Date {
    const localDate = DateTime.fromJSDate(date);
    const timezoneDate = DateTime.fromObject({
        year: localDate.year,
        month: localDate.month,
        day: localDate.day,
        hour: localDate.hour,
        minute: localDate.minute,
        second: localDate.second
    }, { zone: timezone });

    return timezoneDate.toJSDate();
}

export function getTimezoneDateTime(utcMilliseconds: number, timezone: string): DateTime {
    const date = new Date(utcMilliseconds);

    const localDate = DateTime.fromJSDate(date);
    localDate.setZone(timezone);

    return localDate;
}

export function utcMillisecondsToLocalDate(utcMilliseconds: number): Date {
    const localTime = DateTime.fromMillis(utcMilliseconds);
    const utcTime = localTime.toUTC();

    const date = new Date(
        utcTime.year,
        utcTime.month - 1,
        utcTime.day,
        utcTime.hour,
        utcTime.minute,
        utcTime.second
    );

    return date;
}

export function utcMillisecondsToUtcDateTime(utcMilliseconds: number): DateTime {
    const localTime = DateTime.fromMillis(utcMilliseconds);
    const utcTime = localTime.toUTC();
    return utcTime;
}

export function localDateToUtcMilliseconds(date: Date | null): number {
    if (!date) {
        return 0;
    }

    const utcDateTime = DateTime.utc(date.getFullYear(), date.getMonth() + 1, date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    return utcDateTime.toMillis();
}